import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Elementary.",
  "description": "",
  "published": "2012-10-02T00:00:00.000Z",
  "redirect_from": ["/blog/elementary/swizec/5354"],
  "categories": "BBC, CBS, London, New York City, Scotland Yard, Sherlock, Sherlock Holmes, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><a parentName="p" {...{
        "href": "http://swizec.com/blog/wp-content/uploads/2012/10/elementary-title-scene.png"
      }}><img parentName="a" {...{
          "src": "https://swizec.com/blog/wp-content/uploads/2012/10/elementary-title-scene-1024x576.png",
          "alt": "Elementary title scene",
          "title": "Elementary title scene"
        }}></img></a></p>
    <p>{`Being the paragon of originality, american television creators are doing yet another remake of an amazing `}<a parentName="p" {...{
        "href": "http://www.bbc.co.uk/",
        "title": "BBC"
      }}>{`BBC`}</a>{` series. This time they're taking a shot at `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Sherlock_%28TV_series%29",
        "title": "Sherlock (TV series)"
      }}>{`Sherlock`}</a>{`.`}</p>
    <p>{`Unlike their usual efforts, however, they didn't mess this one up. I watched the season premier of Elementary this morning and I have to say it's good. Very good!`}</p>
    <p>{`While the wikipedia page assures me this is not in fact a remake, but a completely independent production, there are still a striking number of similarities between the two. Possibly making a modernization of `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Sherlock_Holmes",
        "title": "Sherlock Holmes"
      }}>{`Sherlock Holmes`}</a>{` into the current time, simply looks very similar, it's nontheless obvious CBS was influenced by BBC's Sherlock.`}</p>
    <p>{`That paragraph didn't make a lot of sense. I'm saying they're similar. Very similar.`}</p>
    <p><a parentName="p" {...{
        "href": "http://swizec.com/blog/wp-content/uploads/2012/10/sherlock-title-scene.png"
      }}><img parentName="a" {...{
          "src": "https://swizec.com/blog/wp-content/uploads/2012/10/sherlock-title-scene-1024x577.png",
          "alt": "Sherlock title scene",
          "title": "Sherlock title scene"
        }}></img></a></p>
    <p>{`For instance, look at the title screen - `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Establishing_shot",
        "title": "Establishing shot"
      }}>{`establishing shot`}</a>{` of the city and title of show. London in the morning, New York City in the evening.`}</p>
    <p>{`Coincidentally, BBC's show is about a young Sherlock in his prime. `}<a parentName="p" {...{
        "href": "http://www.cbs.com/",
        "title": "CBS"
      }}>{`CBS's`}</a>{` Elementary is about Sherlock Holmes after a career as a Scotland Yard consultant who fled to Brooklyn to treat some manner of drug addiction.`}</p>
    <p>{`Interesting.`}</p>
    <p>{`Both shows feature great production values, awesome music, three episodes per season and terrific acting. Can I call two shows similar because they're both high quality?`}</p>
    <p>{`Is that a thing? Have we really gone so far that "being well made" is a recognizable trait of a television series? That's sad ...`}</p>
    <p>{`That said, Elementary features a lovely twist on the Sherlock Holmes universe - Watson is a woman. Played by Lucy Liu of all people. Marvelous! Don't worry, it's still going to be a bromance, except one of the bros is a girl.`}</p>
    <p>{`Can't wait to see more.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/10/cbs-sherlock-holmes-1024x583.png",
        "alt": "CBS's Sherlock Holmes",
        "title": "CBS's Sherlock Holmes"
      }}></img></p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.contactmusic.com/news/how-has-elementary-the-american-sherlock-gone-down-with-critics_3302739"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/noimg_67_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.contactmusic.com/news/how-has-elementary-the-american-sherlock-gone-down-with-critics_3302739"
        }}>{`How has Elementary - The American Sherlock - gone down with critics?`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://brouhaha-access.com/2012/09/26/a-new-twist-on-an-old-story-of-sherlock-holmes-elementary/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/114676614_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://brouhaha-access.com/2012/09/26/a-new-twist-on-an-old-story-of-sherlock-holmes-elementary/"
        }}>{`A New Twist On An Old Story of Sherlock Holmes-Elementary`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://blog.films.ie/2012/08/sherlock-gets-us-makeover-with-cbs-elementary.html"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/108782354_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://blog.films.ie/2012/08/sherlock-gets-us-makeover-with-cbs-elementary.html"
        }}>{`Sherlock Gets US Makeover With CBS Elementary`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.rr.com/tv/topic/article/rr/51528047/75608447/Elementary_Premiere_Modern_Day_Sherlock_Takes_On"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/noimg_12_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.rr.com/tv/topic/article/rr/51528047/75608447/Elementary_Premiere_Modern_Day_Sherlock_Takes_On"
        }}>{`Elementary Premiere: Modern Day Sherlock Takes On NYC`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.geardiary.com/2012/09/28/new-sherlock-holmes-show-elementary-pilot-free-on-itunes/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/115208896_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.geardiary.com/2012/09/28/new-sherlock-holmes-show-elementary-pilot-free-on-itunes/"
        }}>{`New Sherlock Holmes Show "Elementary" Pilot Free on iTunes`}</a></li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=88451305-aecb-423c-a3f2-f77d25b184fe",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      